import Vue from 'vue'
export const bus = new Vue()
// const bus = new Vue()
// export default bus


// WEBPACK FOOTER //
// ./src/bus.js